import React from 'react';
import { useTranslator, FormikCheckboxInput as Checkbox } from '@front-activerse/common-components';
import { Container, Row, Col, Button, Spinner } from 'reactstrap';

interface TrackerMealStickyFooterProps {
  isEditMode: boolean;
  hasAddUserMeal: boolean;
  isSubmitting: boolean;
  isFormValid: boolean;
  onSubmit: () => void;
  submitValues: Record<string, unknown>;
  fromUserMeals?: boolean;
}

const TrackerMealStickyFooter: React.FC<TrackerMealStickyFooterProps> = ({
  isEditMode,
  hasAddUserMeal,
  isSubmitting,
  isFormValid,
  onSubmit,
  submitValues,
  fromUserMeals,
}) => {
  const { t } = useTranslator();

  return (
    <div className="sticky-footer">
      <Container className="px-3">
        <Row>
          <Col xs="12" md={{ size: 4, offset: 4 }}>
            {!isEditMode && !hasAddUserMeal && !fromUserMeals && (
              <div
                className={
                  isFormValid ? 'save-your-meal-container' : 'save-your-meal-container opacity-50'
                }
              >
                <Checkbox name="saveYourMeal" disabled={!isFormValid}>
                  <p className="mb-0 small text-text-variant-color">
                    {t('tracker.logToTracker.saveYourMeal.checkbox')}
                  </p>
                </Checkbox>
              </div>
            )}
            <Button
              type="button"
              onClick={() => onSubmit()}
              color="primary"
              className="w-100"
              disabled={isSubmitting || !isFormValid}
            >
              {isSubmitting ? (
                <>
                  <Spinner />
                  <span className="ms-2">{t('data-processing')}</span>
                </>
              ) : isEditMode ? (
                t('tracker.mealDetails.saveButton')
              ) : fromUserMeals ? (
                t('yourMeal.addToMealsButton')
              ) : (
                t('tracker.meal.logButton')
              )}
            </Button>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default TrackerMealStickyFooter;
